export * from './FileGiveHandIcon'
